package app.alefly.domain.model

/**
 * Fonte única de conversão entre [Difficulty] e seu valor de fio (wire value).
 *
 * O wire value é sempre o nome do enum em minúsculas (`easy`, `medium`, `hard`, `random`),
 * coincidindo com os `@SerialName` declarados em [Difficulty].
 */
fun Difficulty.wireValue(): String = name.lowercase()

/**
 * Converte um wire value em [Difficulty]. Valores desconhecidos (ou em branco)
 * caem para [Difficulty.MEDIUM]. A entrada é normalizada com `trim().lowercase()`.
 */
fun difficultyFromWire(value: String): Difficulty = when (value.trim().lowercase()) {
    "easy" -> Difficulty.EASY
    "hard" -> Difficulty.HARD
    "random" -> Difficulty.RANDOM
    else -> Difficulty.MEDIUM
}
